import React from 'react';
import { useStorefront3DStore } from '../../store/useStorefront3DStore';

const Lighting = () => {
  const { viewerSettings } = useStorefront3DStore();

  return (
    <>
      {/* Ambient Light */}
      <ambientLight 
        intensity={viewerSettings.ambientIntensity || 0.4} 
        color="#ffffff" 
      />
      
      {/* Main Directional Light (Sun) */}
      <directionalLight
        position={[10, 10, 5]}
        intensity={viewerSettings.directionalIntensity || 1}
        castShadow={viewerSettings.shadows !== false}
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={50}
        shadow-camera-left={-20}
        shadow-camera-right={20}
        shadow-camera-top={20}
        shadow-camera-bottom={-20}
      />
      
      {/* Fill Light */}
      <directionalLight
        position={[-5, 5, -5]}
        intensity={0.3}
        color="#b3e5fc"
      />
      
      {/* Rim Light */}
      <pointLight
        position={[0, 8, -10]}
        intensity={0.5}
        color="#fff3e0"
        distance={30}
        decay={2}
      />
      
      {/* Store Ceiling Lights */}
      <pointLight
        position={[5, 4, 5]}
        intensity={0.6}
        color="#ffffff"
        distance={15}
        decay={2}
        castShadow={viewerSettings.shadows !== false}
      />
      
      <pointLight
        position={[-5, 4, 5]}
        intensity={0.6}
        color="#ffffff"
        distance={15}
        decay={2}
        castShadow={viewerSettings.shadows !== false}
      />
      
      <pointLight
        position={[5, 4, -5]}
        intensity={0.6}
        color="#ffffff"
        distance={15}
        decay={2}
        castShadow={viewerSettings.shadows !== false}
      />
      
      <pointLight
        position={[-5, 4, -5]}
        intensity={0.6}
        color="#ffffff"
        distance={15}
        decay={2}
        castShadow={viewerSettings.shadows !== false}
      />
    </>
  );
};

export default Lighting;
